import { Outlet } from "react-router-dom";

function MyTasksMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default MyTasksMain;